import { useGetSystemConfigsAIAgentQuery } from 'services';

export function useSystemConfigAIAgent() {
  const { data: dataResponse, isLoading } = useGetSystemConfigsAIAgentQuery();

  return {
    data: dataResponse?.data,
    isLoading
  };
}
